
export enum enumImageLinkType {
  GoogleCloudStorage = 'GoogleCloudStorage', // image store within GoogleCloudStorage
  ExternalSource = 'ExternalSource', // an image from an external source, such as an image hosted on a website
}